import React, { Component } from "react"
import { connect } from "react-redux"
import Messages from "./modules/common/messages/messages"
import { HashRouter } from "react-router-dom"

import Menu from "./Menu"
import Routes from "./Routes"


class App extends Component {
    constructor(props) {
         super(props)
         this.state = { tiraroerrocompilacao: 0 }

    }

    
    render() {
        return (
            <>
               <HashRouter>
                   <Menu />
                   <Routes />
                   <Messages /> 
               </HashRouter>
            </>
        )
    }

}

export default connect(null, null)(App)